import { branch, dining_table, type PowerSyncDrizzleDB } from "@malla/powersync";
import { nowISO } from "../utils/date-helpers";
import { generateId } from "@fleet/utils";
import { patchRowVerified } from "../powersync/verified-write";

export async function createBranchMutation(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  name: string,
  opts?: { address?: string; timezone?: string },
): Promise<string> {
  const id = generateId();
  const now = nowISO();
  await db.insert(branch).values({
    id,
    organization_id: organizationId,
    name: name.trim(),
    address: opts?.address ?? null,
    timezone: opts?.timezone ?? null,
    created_at: now,
    updated_at: now,
  });
  return id;
}

export type TableStatus = "free" | "occupied" | "bill_requested";

export async function createTableMutation(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  branchId: string,
  name: string,
  opts?: { seats?: number; sortOrder?: number },
): Promise<string> {
  const id = generateId();
  const now = nowISO();
  await db.insert(dining_table).values({
    id,
    organization_id: organizationId,
    branch_id: branchId,
    name: name.trim(),
    seats: opts?.seats ?? 2,
    status: "free",
    sort_order: opts?.sortOrder ?? 0,
    created_at: now,
    updated_at: now,
  });
  return id;
}

export async function setTableStatusMutation(
  db: PowerSyncDrizzleDB,
  tableId: string,
  status: TableStatus,
): Promise<void> {
  await patchRowVerified(db, dining_table, dining_table.id, tableId, { status });
}
